export default "__VITE_ASSET__DHD7u$V$__"